import { Component } from '@angular/core';
import {DataService} from '../../../services/data/data.service';
import {FiltrosService} from '../../../services/riesgo-credito/filtros/filtros.service';
import {MatrizTransicionService} from './../../../services/riesgo-credito/riesgos/matriz-transicion.service';
import { matrizClickEntity, matrizFiltroEntity, matrizTransicionEntity } from './../entities_riesgos/entities_riesgos';
import { formatear} from '../../funciones/funcionesGenerales';
import {FuncionesRiesgo} from './../funciones_riesgos';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoCredito } from '../../../shared/catalogos';
import { firstValueFrom } from 'rxjs';
import { FiltersM } from '../../../components/models';
import moment from 'moment';
import { messages } from '../../funciones/mensajes';
import { PeriodosService } from '../../../services/riesgo-credito/riesgos/periodos.service';
import { MatrizClickService } from '../../../services/riesgo-credito/riesgos/matriz-click.service';
import Swal from 'sweetalert2';
import { TextUtils } from '../../../components/pipes/text-utils';
import { MatrizFiltroService } from '../../../services/riesgo-credito/riesgos/matriz-filtro.service';

@Component({
  selector: 'app-matriz-transicion',
  templateUrl: './matriz-transicion.component.html',
  styleUrl: './matriz-transicion.component.css'
})
export class MatrizTransicionComponent {
  public Filtros = FiltersM;
  /* Declaración de variables */
  public idInstitucion = 1002;
  public Periodos = [];
  public Periodos2 = [];
  public periodoActual: any;
  public periodoAnterior: any;
  public DatosAnios;
  public puedeFiltrarPorMeses = false;
  public puedeFiltrarPorSucursales = false;
  public sucursalesDisponibles: any[];
  public sucursalSeleccionada: object;
  public subtituloGrafica:string = "";
  public subtituloGraficaII:string = "";
  public mesAnio:string = "";
  dataSource:any[] = [];
  dataTotales = [];
  dataMatriz1:any[] = [];
  dataMatriz2:any[] = [];
  dataSourceII:any[] = [];
  total_diagonal: number = 0;
  total_arribadiagonal: number = 0;
  total_abajodiagonal: number = 0;
  total_diagonalII: number = 0;
  total_arribadiagonalII: number = 0;
  total_abajodiagonalII: number = 0;
  matrizTransicionEntity = new matrizTransicionEntity;
  mTRClickEntity = new matrizClickEntity;
  mTRFiltroEntity = new matrizFiltroEntity;
  array_total:number [] = [0,0,0,0,0,0,0,0,0];
  array_totalII:any [] = [0,0,0,0,0,0,0,0,0];
  flag_zona: boolean = false;
  flag_sucursal: boolean = false;
  zona_name: string = "";
  flag_producto: boolean = false;
  producto_name: string = "";
  dataClick = [];
  private txtPeriodo;
  // VARIABLES PERSONALIZACION CATALAGO
  private bndInteres: boolean; // false -> sin intereses   true -> con intereses
  public submenus: number; 
  public moneda: String;

  showModal: boolean = false;
  titulomodal: string = "";
  subtitulomodal: string = "";
  tablamonto_modal:boolean = false;
  tablacreditos_modal: boolean = false;
  tablacuentas_modal: boolean = false;
  data_excel: any  [] = [];
  public metrica: string = 'general'; // general > matriz genereal, categoria > porcentaje renglon, total > porcentaje total
  public filtroActivado = false;
  public miles : string = ',';
  public decimal : string = '.';
  public modalOpen: boolean = false;
  public labelsModal: boolean;
  public iconoExportar: string;
  constructor(
    public dataService: DataService,
    private filtrosService: FiltrosService,
    private matrizTransicionService: MatrizTransicionService,
    private matrizTRFiltro: MatrizFiltroService,
    private matrizClick: MatrizClickService,
    private excelService: ExcelService,
    private periodosService: PeriodosService,
    private translate: TranslateService,
    private cookies: CookieService
  ){
    formatear.momentAbrev();
    this.idInstitucion = Number(cookies.get('idInstitucion')); 
    this.personalizacion();
    this.getPeriodos();
  }
  ngOnInit(): void {}
  public filterChange(filtro){
    this.filtroActivado = true;
    this.txtPeriodo = `${this.periodoAnterior.mes} • ${this.periodoAnterior.an} - ${this.periodoActual.mes} • ${this.periodoActual.an} `
    switch (filtro.filtro){
      case 'zona': 
        this.filtrarZona(filtro.elem);
        break;
      case 'sucursal':
        this.filtrarSucursal(filtro.elem);
        break;
      case 'producto': 
        this.filtrarProducto(filtro.elem);
        break;
      case 'sector':
        this.filtrarSectores(filtro.elem);
        break;
      case 'asesor':
        this.filtrarAsesor(filtro.elem);
        break;
    }
  }
  private personalizacion(){
    var configInst = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion);
    this.bndInteres = configInst.interes;
    this.submenus = configInst.tipoMenu;
    this.moneda = configInst.moneda;
  }
  private async getPeriodos(){
    const info = await firstValueFrom(
      this.periodosService.getByAddUrl_Riesgo('informacionCargada', {InstitucionId: this.idInstitucion})
    );
    if(info.length > 0){
      this.DatosAnios = formatear.periodosRC(info);
      this.DatosAnios = this.DatosAnios.aniosDisponibles.map( anio => {
        const meses = this.DatosAnios.mesesDisponibles
        .filter( m => Number(m.year) === anio.value)
        .map( m => {
          const nmes = Number(m.value.slice(4, 6)); // 07 → 7
          const anioCorto = String(anio.value).slice(-2);
          return {
            mes: m.name,
            nmes,
            check: false,
            an: anio.value,
            anio: anioCorto,
            value: m.value,
            periodo: `${m.name} ${anioCorto}`,
            visible: true,
            utilizable: true
          };
        });
        return {
          anio: anio.value,
          series: meses,
          visible: true,
          utilizable: true
        };
      })
      this.getConsultas();
    }else{
      var nombre = companiesRiesgoCredito.find(c => Number(c.id) === this.idInstitucion).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }
  }
  filtrarZona(zona){
    this.flag_zona = true;
    this.flag_producto = false;
    this.zona_name = zona.Nombre_Zona;
    this.mTRFiltroEntity.ZonaId = zona.ZonaId;    
    this.mTRFiltroEntity.ProductoId = -1;
    this.mTRFiltroEntity.SectorId = -1;
    this.mTRFiltroEntity.SucursalId = -1;
    this.mTRFiltroEntity.AsesorId = -1;
    this.Funtion_matrizTransicionFiltro(this.mTRFiltroEntity);
    this.subtituloGrafica = this.txtPeriodo + " | matriz | Región " + TextUtils.capitalize(zona.Nombre_Zona,'words');
    this.subtituloGraficaII = this.txtPeriodo + " | matriz | Región " + TextUtils.capitalize(zona.Nombre_Zona,'words');
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`;
  }
  filtrarSucursal(sucursal){
    this.flag_sucursal = true;
    this.flag_producto = false;
    this.zona_name = sucursal.Nombre_Sucursal;
    this.mTRFiltroEntity.ZonaId = -1;    
    this.mTRFiltroEntity.ProductoId = -1;
    this.mTRFiltroEntity.SectorId = -1;
    this.mTRFiltroEntity.SucursalId = sucursal.SucursalId;
    this.mTRFiltroEntity.AsesorId = -1;
    this.Funtion_matrizTransicionFiltro(this.mTRFiltroEntity);
    this.subtituloGrafica = `${this.txtPeriodo}| matriz | Oficina ${TextUtils.capitalize(sucursal.Nombre_Sucursal,'words')}`;
    this.subtituloGraficaII = `${this.txtPeriodo}| matriz | Oficina ${TextUtils.capitalize(sucursal.Nombre_Sucursal,'words')}`;
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`;
  }
  filtrarProducto(producto){
    this.flag_producto = true;
    this.flag_zona = false;
    this.mTRFiltroEntity.ZonaId = -1;    
    this.mTRFiltroEntity.ProductoId = producto.ProductoId;
    this.mTRFiltroEntity.SectorId = -1;
    this.mTRFiltroEntity.SucursalId = -1;
    this.mTRFiltroEntity.AsesorId = -1;
    this.Funtion_matrizTransicionFiltro(this.mTRFiltroEntity);
    var nombre = this.submenus == 0 ? TextUtils.capitalize(producto.Nombre_Producto,'words'): producto.Nombre_Producto;
    this.subtituloGrafica = this.txtPeriodo + "| matriz | Producto " + nombre;
    this.subtituloGraficaII = this.txtPeriodo + "| matriz | Producto " + nombre;
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`;
  }  
  filtrarSectores(sector){
    this.flag_producto = true;
    this.flag_zona = false;
    this.mTRFiltroEntity.ZonaId = -1;    
    this.mTRFiltroEntity.ProductoId = -1;
    this.mTRFiltroEntity.SectorId = sector.SectorId;
    this.mTRFiltroEntity.SucursalId = -1;
    this.mTRFiltroEntity.AsesorId = -1;
    this.Funtion_matrizTransicionFiltro(this.mTRFiltroEntity);
    this.subtituloGrafica = this.txtPeriodo + " | matriz | Sector " + TextUtils.capitalize(sector.Nombre_Sector,'words');
    this.subtituloGraficaII = this.txtPeriodo + " | matriz | Sector " + TextUtils.capitalize(sector.Nombre_Sector,'words');
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`;
  }
  filtrarAsesor(asesor){
    this.flag_producto = true;
    this.flag_zona = false;
    this.mTRFiltroEntity.ZonaId = -1;    
    this.mTRFiltroEntity.ProductoId = -1;
    this.mTRFiltroEntity.SectorId = -1;
    this.mTRFiltroEntity.SucursalId = -1;
    this.mTRFiltroEntity.AsesorId = asesor.AsesorId;
    this.Funtion_matrizTransicionFiltro(this.mTRFiltroEntity);
    this.subtituloGrafica = this.txtPeriodo + " | matriz | Asesor " + TextUtils.capitalize(asesor.Nombre_Asesor,'words');
    this.subtituloGraficaII = this.txtPeriodo + " | matriz | Asesor " + TextUtils.capitalize(asesor.Nombre_Asesor,'words');
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`;
  }
  private getMesesConsulta(){
    this.matrizTransicionEntity.InstitucionId = this.idInstitucion;
    this.matrizTransicionEntity.Periodo = this.periodoActual.value;
    this.matrizTransicionEntity.PeriodoAnterior = this.periodoAnterior.value;
    this.matrizTransicionEntity.TipoCreditoId = -1
    this.matrizTransicionEntity.BnIntereses = this.bndInteres;
    this.matrizTransicionEntity.ZonaId = -1;    
    this.matrizTransicionEntity.ProductoId = -1;
    this.matrizTransicionEntity.SectorId = -1;
    this.matrizTransicionEntity.SucursalId = -1;
    this.matrizTransicionEntity.AsesorId = -1;
    this.mTRFiltroEntity.InstitucionId = this.idInstitucion;
    this.mTRFiltroEntity.Periodo = this.periodoActual.value;
    this.mTRFiltroEntity.PeriodoAnterior = this.periodoAnterior.value;
    this.mTRFiltroEntity.BnIntereses = this.bndInteres;

    this.Funtion_matrizTransicion(this.matrizTransicionEntity);
    this.subtituloGrafica = `${this.periodoAnterior.periodo} - ${this.periodoActual.periodo}`;
    this.subtituloGraficaII = `${this.periodoAnterior.periodo} - ${this.periodoActual.periodo}`;
    this.mesAnio = `${this.periodoActual.mes} • ${this.periodoActual.anio}`; 
  }
  public getConsultas(){
    this.Periodos = this.DatosAnios.map(p => ({...p,series: p.series.map(s => ({ ...s }))}));
      this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = true;
      this.periodoActual = this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1];
      this.Periodos2 = this.DatosAnios.map(p => ({...p,series: p.series.map(s => ({ ...s }))}));
      const lastYearIndex = this.Periodos.length - 1;
      const lastYear = this.Periodos[lastYearIndex];
      const lastMonthIndex = lastYear.series.length - 1;

      // Periodo anterior
      let prevYearIndex = lastYearIndex;
      let prevMonthIndex = lastMonthIndex - 1;

      // Si el último mes es el único del año (ej: enero)
      if (prevMonthIndex < 0) {
        prevYearIndex = lastYearIndex - 1;

        if (prevYearIndex >= 0) {
          const prevYear = this.Periodos2[prevYearIndex];
          prevMonthIndex = prevYear.series.length - 1;
        }
      }
      if (prevYearIndex >= 0 && prevMonthIndex >= 0) {
        this.Periodos2[prevYearIndex].series[prevMonthIndex].check = true;
        this.periodoAnterior = this.Periodos2[prevYearIndex].series[prevMonthIndex];
      }
    this.getMesesConsulta();
  }
  columnas = [];
  public async Funtion_matrizTransicion(matrizTransicionEntity){
    const res = await firstValueFrom(
      this.matrizTransicionService.getByAddUrl_Riesgo('matrizTR/matriz-general',matrizTransicionEntity)
    );
    this.ConvertirMatrizTransicionTabla(res);
  }
  public async Funtion_matrizTransicionFiltro(matrizTransicionEntity){
    const res = await firstValueFrom(
      this.matrizTRFiltro.getByAddUrl_Riesgo('matrizTR/matriz-general',matrizTransicionEntity)
    );
    this.ConvertirMatrizTransicionTabla(res);
  }
  public ConvertirMatrizTransicionTabla(dataArr){
    let auxM = [];
    let auxM2 = [];
    this.dataSource = [];
    this.dataSourceII = [];
    this.dataTotales = [];
    //primero verificar el número de row del arreglo 
    let rows = [];
    let columnas: any[] = [];
    for(const dato of dataArr){
      if(!columnas.includes(dato['Nombre_CategoriaCredito_R'])){
        columnas.push(dato['Nombre_CategoriaCredito_R']);
      }
    }
    this.columnas = columnas;
    for(const dato of dataArr){
      if(!rows.includes(dato['Renglon'])){
        rows.push(dato['Renglon']);
      }                                       
    }
    this.total_diagonal = 0;
    this.total_abajodiagonal = 0;
    this.total_arribadiagonal = 0;
    this.total_diagonalII = 0;
    this.total_abajodiagonalII = 0;
    this.total_arribadiagonalII = 0;

    for(const row of rows){
      const colums = dataArr.filter(d => d['Renglon'] === row);
      var i=0, total = 0, total2 = 0;
      auxM = [];
      auxM2 = [];
      auxM.push(colums[0].Nombre_CategoriaCredito_R);
      auxM2.push(colums[0].Nombre_CategoriaCredito_R);

      colums.forEach( elem => {
        //Suma diagonales
        if(elem['Columna'] === elem['Renglon']){
          this.total_diagonal += Number(elem.Value)?Number(elem.Value):0;
          this.total_diagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
        }
        if(elem['Columna'] < elem['Renglon']){
          this.total_abajodiagonal += Number(elem.Value)?Number(elem.Value):0;
          this.total_abajodiagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
        }
        if(elem['Columna'] > elem['Renglon']){
          this.total_arribadiagonal += Number(elem.Value)?Number(elem.Value):0;
          this.total_arribadiagonalII += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0
        }
        //Tabla de saldos
        auxM.push(Number(elem.Value)?
                  {
                    value:Number(elem.Value),
                    idAct: elem.CategoriaCreditoId_C,
                    idAnt: elem.CategoriaCreditoId_R
                  }:
                  {
                    value:0,
                    idAct: elem.CategoriaCreditoId_C,
                    idAnt: elem.CategoriaCreditoId_R
                  }
                );
        total += Number(elem.Value)?Number(elem.Value):0;
        //Tabla de créditos
        auxM2.push(Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0);
        total2 += Number(elem.NumeroCreditos)?Number(elem.NumeroCreditos):0;

        i++;
      });
      auxM.push(Number(total.toFixed(2)));
      auxM2.push(total2);

      this.dataSource.push(auxM);
      this.dataSourceII.push(auxM2);
    }

    var suma = this.dataSource.reduce((acum, fila) => {
      fila.slice(1).forEach((celda, j) => {
        acum[j] = (acum[j] ?? 0) + Number(celda?.value ?? celda ?? 0);
      });
      return acum;
    }, []);

    suma = ["Total", ...suma];
    const suma2 = this.dataSourceII.reduce( (acum, fila) => 
      fila.map( (num, j) => ( (Number(acum[j]) || 0) + (Number(num) || 0) ) , [] )
    );
    suma2[0] = 'Total';

    this.dataSource.push(suma);
    this.dataSourceII.push(suma2);
    this.dataTotales.push(this.total_diagonal);
    this.dataTotales.push(this.total_abajodiagonal);
    this.dataTotales.push(this.total_arribadiagonal);
    this.dataTotales.push(this.total_diagonalII);
    this.dataTotales.push(this.total_abajodiagonalII);
    this.dataTotales.push(this.total_arribadiagonalII);
    this.cambioMetrica(this.metrica);    
  }
  /* funciones para los filtros */
  public periodoChangeListener(per: object): void {
    this.periodoActual = per;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.value === per['value']){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.getMesesConsulta();
  }
  public periodo2ChangeListener(per: object): void {
    this.periodoAnterior = per;
    for(const an of this.Periodos2){
      for(const mes of an.series){
        if(mes.value === per['value']){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.getMesesConsulta();
  }
  public cambioMetrica(metrica){
    this.metrica = metrica;
    this.dataMatriz1 = [];
    this.dataMatriz2 = [];
    this.txtPeriodo = `${this.periodoAnterior.mes} • ${this.periodoAnterior.an} - ${this.periodoActual.mes} • ${this.periodoActual.an} `
    switch(metrica){
      case 'total':
        this.calcularPorcentajeTotal();
        this.calcularTotalesTarjetas();
        this.subtituloGrafica = `${this.txtPeriodo}| matriz | % total`;
        this.subtituloGraficaII = `${this.txtPeriodo}| matriz | % total`;
        break;
      case 'categoria':
        this.calcularPorcentajeCategoría();
        this.calcularTotalesTarjetas();
        this.subtituloGrafica = `${this.txtPeriodo}| matriz | % categoría`;
        this.subtituloGraficaII = `${this.txtPeriodo}| matriz | % categoría`;
        break;
      default:
        this.dataMatriz1 = this.dataSource;
        console.debug("🚀 ~ MatrizTransicionComponent ~ cambioMetrica ~ this.dataMatriz1:", this.dataMatriz1)
        this.dataMatriz2 = this.dataSourceII;
        this.total_diagonal = this.dataTotales[0];
        this.total_abajodiagonal = this.dataTotales[1];
        this.total_arribadiagonal = this.dataTotales[2];
        this.total_diagonalII = this.dataTotales[3];
        this.total_abajodiagonalII = this.dataTotales[4];
        this.total_arribadiagonalII = this.dataTotales[5];
        this.subtituloGrafica = !this.filtroActivado ? `${this.periodoAnterior.periodo} - ${this.periodoActual.periodo}` : this.subtituloGrafica;
        this.subtituloGraficaII = !this.filtroActivado ? `${this.periodoAnterior.periodo} - ${this.periodoActual.periodo}` : this.subtituloGraficaII;
        break;
    }
  }
  //CALCULOS DE METRICAS
  private calcularPorcentajeCategoría(){
    var aux = [], aux2 = [];
    for(const renglon of this.dataSource){
      if(renglon[0] !== 'Total'){
        aux = [];
        for(let i = 0; i < renglon.length; i++){
          if(i == 0){
            aux.push(renglon[i]);
          }
          if(i !== 0 && i !== renglon.length-1){
            aux.push({
              idAct: renglon[i].idAct,
              idAnt: renglon[i].idAnt,
              value: Number((renglon[i].value / renglon[renglon.length-1] * 100).toFixed(2)) || 0
            })
          }        
        }
        this.dataMatriz1.push(aux)
      }      
    }
    for(const renglon of this.dataSourceII){
      if(renglon[0] !== 'Total'){
        aux2 = [];
        for(let i = 0; i < renglon.length; i++){
          if(i == 0){
            aux2.push(renglon[i]);
          }
          if(i !== 0 && i !== renglon.length-1){
            aux2.push(Number((renglon[i] / renglon[renglon.length-1] * 100).toFixed(2)) || 0);
          }        
        }
        this.dataMatriz2.push(aux2);
      }      
    }
  }
  private calcularPorcentajeTotal(){
    var aux = [], aux2 = [];
    var total = this.dataSource[this.dataSource.length-1][this.dataSource[0].length-1];
    for(const renglon of this.dataSource){
      aux = [];
      for(let i = 0; i < renglon.length; i++){
        if(i == 0){
          aux.push(renglon[i]);
        }else{
          if(renglon[0] !== 'Total'){        
            if(i !== renglon.length-1){
              aux.push({
                idAct: renglon[i].idAct,
                idAnt: renglon[i].idAnt,
                value: Number((renglon[i].value / total * 100).toFixed(2))
              })
            }else{
              aux.push(Number((renglon[i] / total * 100).toFixed(2)));
            } 
          }else{
            aux.push(Number((renglon[i] / total * 100).toFixed(2)));
          }     
        }
      }   
      this.dataMatriz1.push(aux);
    }
    total = this.dataSourceII[this.dataSourceII.length-1][this.dataSourceII[0].length-1]
    for(const renglon of this.dataSourceII){
      aux2 = [];
      for(let i = 0; i < renglon.length; i++){
        if(i == 0){
          aux2.push(renglon[i]);
        }else{
          aux2.push(Number((renglon[i] / total * 100).toFixed(2)));
        }        
      }
      this.dataMatriz2.push(aux2)        
    }
  }
  private calcularTotalesTarjetas(){
    var total = this.dataSource[this.dataSource.length-1][this.dataSource[0].length-1];
    this.total_diagonal = Number((this.dataTotales[0] / total * 100).toFixed(3));
    this.total_abajodiagonal = Number((this.dataTotales[1] / total * 100).toFixed(3));
    this.total_arribadiagonal = Number((this.dataTotales[2] / total * 100).toFixed(3));
    total = this.dataSourceII[this.dataSourceII.length-1][this.dataSourceII[0].length-1];
    this.total_diagonalII = Number((this.dataTotales[3] / total * 100).toFixed(3));
    this.total_abajodiagonalII = Number((this.dataTotales[4] / total * 100).toFixed(3));
    this.total_arribadiagonalII = Number((this.dataTotales[5] / total * 100).toFixed(3));
  }
  // SUCURSALES
  public consolidadoChangeListener(): void {
    /*this.consolidado = !this.consolidado;
    if (!this.consolidado) {
      if (this.mesSeleccionado) {
        this.filtrosService.changeAllElementsCheckStatus(this.mesesDeAnioDisponibles, false);
        // @ts-ignore
        this.mesSeleccionado.check = true;
        this.getTablaPorMes();
      }
      this.getGraficaPorSucursales();
    }else {
      // Si es consolidado entonces volvemos a la grafica por mes
      this.getGraficaPorMes();
    }*/
  }
  public sucursalChangeListener(sucursalClick: object): void {
    /*if (this.mesSeleccionado) {
      this.filtrosService.changeAllElementsCheckStatus(this.mesesDeAnioDisponibles, false);
      // @ts-ignore
      this.mesSeleccionado.check = true;
    }
    this.filtrosService.changeElementCheckStatus(sucursalClick, this.sucursalesDisponibles);
    this.numeroDeSucursalesSeleccionadas = this.sucursalesDisponibles.filter(e => e.check).length;
    this.puedeFiltrarPorPerspectivas = (this.numeroDeSucursalesSeleccionadas === 1);
    this.getGraficaPorSucursales();
    if (this.puedeFiltrarPorPerspectivas) {
      this.sucursalSeleccionada = this.sucursalesDisponibles.find(e => e.check);
    }*/
  }
  public quitarFiltros(): void {
    // this.matrizTransicionEntity.BnConIntereses = this.bndInteres;
    this.matrizTransicionEntity.ProductoId = null;
    this.matrizTransicionEntity.SectorId = null;
    this.matrizTransicionEntity.ZonaId = null;
    this.matrizTransicionEntity.SucursalId = null;

    this.filtroActivado = false;
    this.metrica = 'general';

    this.getConsultas();
  }
  /* Otras funciones */
  PintarCelda(x,y){
    if (y == this.columnas.length)
      return "";
    if(x == y){
      return "w3-light-gray"
    }
    if(x > y){
      return "w3-orange2"
    }
    if(x < y){
      return "w3-light-green2"
    }else
      return '';
  }
  formatearnormal(num){
    let cantidad = FuncionesRiesgo.formatearnormal(num);
    if(cantidad == "0.00"){
      cantidad ="0";
    }
    return cantidad;
  }
  formatearnormalCredito(num){
    let cantidad = FuncionesRiesgo.formatearnormalCredito(num);
    if(cantidad == "0"){
      cantidad = "0";
    }
    return cantidad;
  }
  public Ampliar(zona){
    this.modalOpen = true;
    if(zona == 1){
      this.titulomodal = this.translate.instant("riesgo-credito.matriz.enc1");
      this.tablamonto_modal = true;
      this.subtitulomodal = this.subtituloGrafica;    
    }
    if(zona == 2){
      this.titulomodal = this.translate.instant("riesgo-credito.matriz.enc2");
      this.tablacreditos_modal = true;
      this.subtitulomodal = this.subtituloGrafica; 
    }
    if(zona == 3) { //se muestran las cuentas
      this.titulomodal = this.translate.instant("riesgo-credito.matriz.cuentas");
      this.tablacuentas_modal = true;
      this.subtitulomodal = this.mesAnio; 
    }   
        
  }
  public cerrarModal(){
    this.modalOpen = false;
    this.tablamonto_modal = false;
    this.tablacreditos_modal = false;
    this.tablacuentas_modal = false;
  }
  exportar_csv(tipo){
    this.data_excel = [];
    if(tipo == "monto"){
      let enc = [];
      enc.push("");
      for (const ele of this.dataMatriz1){
        enc.push(ele[0]);
        let aux = [];
        for(const d of ele){
          if(this.metrica == 'general')
            aux.push(typeof d === 'object' ? d.value : d);
          else{
            if(typeof d === 'string')
              aux.push(d);
            else
              aux.push(typeof d === 'object' ? d.value/100 : d/100)
          }
        }
        this.data_excel.push(aux)
      }
      let nombreArch = `${this.translate.instant('riesgo-credito.matriz.nombreArchMonto')} ${this.periodoActual.periodo}`;
      let titHoja = this.translate.instant('menu.'+this.dataService.moduleSelect) + " • " + this.translate.instant('riesgo-credito.matriz.titArchivoMonto') + this.subtituloGrafica;
      this.excelService.generatoExcelMatrizTransicionMonto(titHoja, enc,this.data_excel,nombreArch, this.metrica);
    }
    if(tipo == "creditos"){
      let enc = [];
      enc.push("");
      for (const ele of this.dataMatriz2){
        enc.push(ele[0]);
        let aux = [];
        for(const d of ele){
          aux.push(this.metrica === 'general' ? d : typeof d === 'number' ? d / 100 : d);
        }
        this.data_excel.push(aux)
      }
      let nombreArch2 = `${this.translate.instant('riesgo-credito.matriz.nombreArchCreditos')} ${this.periodoActual.periodo}`;
      let titHoja2 = this.translate.instant('menu.'+this.dataService.moduleSelect) + " • " + this.translate.instant("riesgo-credito.matriz.titArchivoCreditos") + this.subtituloGrafica;
      this.excelService.generatoExcelMatrizTransicionCredito(titHoja2, enc,this.data_excel,nombreArch2, this.metrica);
    }
  }
  async getCuentas(elem){
    messages.messageSaving(this.translate.instant('swal.obteniendo'), this.translate.instant('swal.espere'))
    this.dataClick = [];
    this.mTRClickEntity.InstitucionId = this.idInstitucion;
    this.mTRClickEntity.Periodo = this.matrizTransicionEntity.Periodo;
    this.mTRClickEntity.PeriodoAnterior = this.matrizTransicionEntity.PeriodoAnterior;
    this.mTRClickEntity.PAR = 30;
    this.mTRClickEntity.BnPAR_Inclusive = 1;
    this.mTRClickEntity.CategoriaCreditoId_Actual = elem.idAct;
    this.mTRClickEntity.CategoriaCreditoId_Anterior = elem.idAnt;
    const res = await firstValueFrom(
      this.matrizClick.getByAddUrl_Riesgo('matrizTR/listado-registros', this.mTRClickEntity)
    );
    if(res.length === 0){
      Swal.close();
      messages.infoMessageGraph(this.translate.instant('swal.sinInformacion'));
      return;
    }
    for(let d of res){
      this.dataClick.push(
        {
          nCredito: d['CreditoId'],
          claveSocio: d['Clave_Socio'],
          sucursal: d['Nombre_Sucursal'],
          nombre: d['Nombre_Socio'],
          diasMora: d['Dias_Mora_Actual'],
          tipoCred: d['Nombre_TipoCredito'],
          producto: d['Nombre_Producto'],
          saldo: d['Saldo_Actual'],
          estatus: d['Nombre_EstatusCredito_Actual']
        }
      )
    }
    Swal.close();
    this.Ampliar(3);
    // document.getElementById("matrizCuentas")!.style.display = "block";
  }
  public exportCuentasMatriz(){
    var headers = [];
    for(var i=1; i <= 9; i++){
      headers.push(this.translate.instant(`riesgo-credito.matriz.tablaCuentasTitulo${i}`));
    }
    
    var alineacion = [
      Aligment.LEFT,
      Aligment.LEFT,
      Aligment.CENTER,
      Aligment.RIGHT,
      Aligment.RIGHT,
      Aligment.CENTER,
      Aligment.CENTER,
      Aligment.CENTER,
      Aligment.LEFT
    ];

    var format = [
      FormatText.TEXT,
      FormatText.NUMBER,
      FormatText.TEXT,
      FormatText.TEXT,
      FormatText.NUMBER,
      FormatText.TEXT,
      FormatText.TEXT,
      FormatText.NUMBER,
      FormatText.TEXT,
    ]
    const data = [];
    for ( const inf of this.dataClick){
      var aux = [];
      
      aux.push(inf.nCredito?inf.nCredito:0);
      aux.push(inf.claveSocio);
      aux.push(inf.sucursal);
      aux.push(inf.nombre);
      aux.push(inf.diasMora);
      aux.push(inf.tipoCred);
      aux.push(inf.producto);
      aux.push(inf.saldo);
      aux.push(inf.estatus);
      
      data.push(aux);
    }
    var tituloHoja = `Cuentas matriz transición`;
    this.excelService.generateExcel(
      tituloHoja,
      headers,
      data,
      this.mesAnio,
      alineacion,
      format
    );
  }
}